import React, { useEffect } from "react";
import { Modal, Input, Select, Button, Form, Checkbox } from "antd";
import "../../styles/Booking_Model.css";
import { useDispatch, useSelector } from "react-redux";
import {
  updatecompany,
  updatePrepaid,
} from "src/redux/actions/bookingReportAction";

interface Prepaid_ModelProps {
  selectedRows: any[];
  visible: boolean;
  onClose: () => void;
  onSubmit: (data: {
    bookingId: string;
    cabId: string;
    company: string;
  }) => void;
}

const { Option } = Select;

const Prepaid_Model: React.FC<Prepaid_ModelProps> = ({
  visible,
  onClose,
  selectedRows,
}) => {
  const select = useSelector((state: any) => state.booking.comdata ?? []);
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");

  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const handleFinish = (values: any) => {
    const payload = {
      bookingid: values.bookingid,
      updatedBy: userData.employeename,
      isCredit: values.isCredit,
    };
    dispatch(updatePrepaid(payload));
    onClose();
    form.resetFields();
  };

  useEffect(() => {
    if (visible && selectedRows.length > 0) {
      form.setFieldsValue({
        bookingid: selectedRows[0].bookingid,
        cabId: selectedRows[0].cabId,
      });
    } else {
      form.resetFields();
    }
  }, [visible, selectedRows]);

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      centered
      className="modern-booking-modal"
      title={<div className="custom-modal-title">Prepaid</div>}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        className="form-center"
      >
        <Form.Item
          name="bookingid"
          rules={[{ required: true, message: "Please enter Booking ID" }]}
        >
          <Input placeholder="Booking ID" className="compact-input" />
        </Form.Item>

        <Form.Item
          name="cabId"
          rules={[{ required: true, message: "Please enter Cab ID" }]}
        >
          <Input placeholder="Cab ID" className="compact-input" />
        </Form.Item>

        <Form.Item name="isCredit" valuePropName="checked">
          <Checkbox>Credit</Checkbox>
        </Form.Item>

        {/* <Form.Item
          name="companyName"
          rules={[{ required: true, message: "Please select Company" }]}
        >
          <Select placeholder="Select Company" className="compact-select">
            {select
              ?.filter(
                (item: any) =>
                  item.companyname &&
                  item.companyname.trim() !== "" &&
                  item.companyname !== "-"
              )
              .map((item: any) => (
                <Option key={item.id} value={item.companyname}>
                  {item.companyname}
                </Option>
              ))}
          </Select>
        </Form.Item> */}

        <Form.Item>
          <Button type="primary" htmlType="submit" className="submit-btn">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Prepaid_Model;
